import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toHref',
})
export class ToHrefPipe implements PipeTransform {
  transform(value: string): unknown {
    if (!value || value.startsWith('http://') || value.startsWith('https://')) {
      return value;
    }

    return 'http://' + value;
  }
}
